import logo from "../assets/logo.webp"
import "../styles/Header.scss"

function Header(){

return <header>
    <img src={logo} alt="Logo Hopnet"/>
</header>
}

export default Header